import { addressSchema, phoneSchema } from "./schemas";

export const submissionSchema = {
  _id: '',
  birthDate: null,
  collectiveName: '',
  phones: [phoneSchema],
  college: '',
  collegeName: '',
  startYear: null,
  endYear: null,
  graduateStatus: '',
  course: '',
  address: addressSchema,
  collectionAddress: addressSchema,
  notes: '',
  statement: '',
  works: [],
  numWorks: 0,
  numMediaItems: 0,
  longRead: false,
  checked: false,
  marked: false,
  return_to: false,
  shortlisted: false,
  hasSelectedWork: false,
  archived: false,
  transactionRef: null,
  feePaid: false,
  deadlineException: false,
  submitted: false,
  createdAt: null,
  modifiedAt: null,
}
